<template>
	<div class="table-view">
		<div class="header" :style="{gridTemplateColumns: _grid_template_columns}">
			<div class="dot" v-if="dot"></div>
			<div class="cell" v-for="(col, i) in _columns" v-bind:key="i">{{ col.label }}</div>
		</div>
		<div class="body">
			<div class="row" :class="{ highlight: item.highlight }" v-for="(item, i) in _items" v-bind:key="i" :style="{gridTemplateColumns: _grid_template_columns}" @click="$emit('item', items[i], $event)">
				<div class="cell dot" v-if="dot">
					<div class="circle" v-if="item.highlight"></div>
				</div>
				<div class="cell" v-for="(col, j) in _columns" v-bind:key="j" :style="{textAlign: col.align}">
					<span v-if="col.type == 'default'">{{ item.data[j] }}</span>
					<button-view v-if="col.type == 'button'" @click.stop="$emit(item.data[j].event, items[i], $event)">{{ item.data[j].label }}</button-view>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'table-view',
		emits: () => true,
		computed: {
			_grid_template_columns() {
				var cols = this.dot ? ['20px'] : [];

				for (var i = 0; i < this._columns.length; ++i) {
					cols.push(this._columns[i].weight);
				}

				return cols.join(' ');
			},
			_items() {
				var items = [];

				for (var i = 0; i < this.items.length; ++i) {
					items.push({
						highlight: this.items[i]._embedded?.highlight || false,
						data: this.normalizeItem(this.items[i]),
					});
				}

				return items;
			},
			_columns() {
				var columns = [];

				for (var i = 0; i < this.columns.length; ++i) {
					columns.push(this.normalizeColumn(this.columns[i]));
				}

				return columns;
			}
		},
		methods: {
			extractData(data, item) {
				var pivot = data;

				if (Array.isArray(data)) {
					pivot = item;

					for (var i = 0; i < data.length; ++i) {
						pivot = item[data[i]];
					}
				}

				

				return pivot;
			},
			transformData(data, col, item) {
				if (data === null) return '-';

				var r = data;

				// Filter
				if (col.filter) {
					r = this.$filters[col.filter](r);
				}

				// Prefix
				if (col.prefix) {
					r = this.extractData(col.prefix, col, item) + r;
				}

				// Suffix
				if (col.prefix) {
					r = r + this.extractData(col.suffix, col, item);
				}

				return r;
			},
			normalizeColumn(column) {
				var col = {
					...{
						type: 'default',
						label: '',
						weight: '1fr'
					},
					...column
				};

				if (col.type == 'default') {
					col = {
						...{
							align: 'left',
							prefix: '',
							suffix: '',
							filter: null,
							data: null
						}, 
						...col
					};
				}

				if (col.type == 'button') {
					col = {
						...{
							data: {
								event: '',
								label: '',
							}
						}, 
						...col
					};
				}

				return col;
			},
			normalizeItem(item, column) {
				var col = null;
				var itm = [];
				
				for (var i = 0; i < this._columns.length; ++i) {
					col = this._columns[i];

					if (col.type == 'default') {
						itm.push(this.transformData(this.extractData(col.data, item), col, item));
					}

					if (col.type == 'button') {
						itm.push({
							event: this.transformData(this.extractData(col.data.event, item), col, item),
							label: this.transformData(this.extractData(col.data.label, item), col, item)
						});
					}
				}

				return itm;
			}
		},
		props: {
			items: {
				required: true,
				type: Array
			},
			columns: {
				requried: true,
				type: Array
			},
			dot: {
				type: Boolean,
				default: false
			},
		},
		mounted() {
			var self = this;

			console.log(self._columns);
			console.log(self._items);
		}
	}
</script>

<style lang="scss" scoped>
	.table-view {
		display: grid;
		grid-template-columns: 1fr;
		grid-template-rows: 40px 1fr;

		& > .header {
			display: grid;
			background-color: white;
			border-bottom: 1px solid rgb(207, 207, 207);
			align-items: center;
			
			& > .cell {
				font-weight: bold;
				padding: 0 0 0 20px;

				&:last-child {
					padding-right: 20px;
				}
			}
		}

		& > .body {
			overflow-y: auto;
		}

		& > .body > .row {
			display: grid;
			height: 40px;
			border-bottom: 1px solid #F5F5F5;
			align-items: center;
			cursor: pointer;

			&.highlight {
				font-weight: bold;
			}

			& > .cell {
				padding: 0 0 0 20px;

				&.dot {
					& > .circle {
						background-color: red;
						width: 6px;
						height: 6px ! important;
						border-radius: 50%;
					}
				}

				&:last-child {
					padding-right: 20px;
				}
			}
		}
	}
</style>